import type { VoidFunctionComponent } from 'react';
import IssuesSelectAllCheckbox from './IssuesSelectAllCheckbox';
import IssueStatusTabs from './IssueStatusTabs';
import IssuesActionDropdown from './IssuesActionDropdown';
import IssuesGroupingDropdown from './IssuesGroupingDropdown';
import IssuesSortingDropdown from './IssuesSortingDropdown';
import Flex from '../../generic/Flex';
import IssuesExpandAllButton from './IssuesExpandAllButton';

/**
 * IssuesTableHeader is the top "bar" of the issues table.
 * When there are no issues selected, it displays the issue status tabs.
 * When there is at least one issue selected, it displays the action buttons.
 * Always displays the select all checkbox and the sorting dropdown.
 */
const IssuesTableHeader: VoidFunctionComponent = () => {
  return (
    <header className="issues-table__header">
      <Flex justify="flex-start" align="center" gap="7px">
        <div className="issues-table__header__icons">
          <IssuesExpandAllButton />
          <IssuesSelectAllCheckbox />
        </div>
        <IssueStatusTabs />
      </Flex>
      <Flex justify="flex-start" align="flex-start" gap="8px">
        <IssuesActionDropdown />
        <IssuesGroupingDropdown />
        <IssuesSortingDropdown />
      </Flex>
    </header>
  );
};

export default IssuesTableHeader;
